module.exports = __webpack_public_path__ + "img/互動日本語.4f26b60b.png";